import React from 'react';
import { Review } from '../types/Review';
import { StarDisplay } from './StarDisplay';


interface Props {
  review: Review;
  replyOpenFor: string | null;
  replyText: string;
  setReplyOpenFor: (id: string | null) => void;
  setReplyText: (text: string) => void;
  onReplySubmit: (review: Review) => void;
  onDeleteReply: (review: Review) => void;
  isAdmin: boolean;
}

export const ReviewItem: React.FC<Props> = ({
  review, replyOpenFor, replyText,
  setReplyOpenFor, setReplyText,
  onReplySubmit, onDeleteReply, isAdmin
}) => {
  const { id, userName, userInitial, message, rating, date, raw } = review;
  const inputCls = `px-3 py-2 rounded-xl text-sm text-blue-900
    border border-blue-200 bg-white placeholder-blue-300
    focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100
    hover:border-blue-400 transition-all duration-200`;

  return (
    <div className="bg-slate-50 rounded-xl border border-blue-50 p-4 hover:bg-blue-50/30 transition-colors duration-150">
      <div className="flex items-start justify-between gap-3 mb-2">
        <div className="flex items-center gap-3">
          
          {raw?.reviewer?.profilePhotoUrl ? (
  <img
    src={raw.reviewer.profilePhotoUrl}
    alt={userName}
    className="w-10 h-10 rounded-full object-cover"
  />
) : (
  <div className="w-10 h-10 rounded-full flex items-center justify-center
                  bg-gradient-to-br from-blue-500 to-blue-400
                  text-white font-bold text-sm">
    {userInitial}
  </div>
)}
          <div>
            <p className="text-sm font-semibold text-blue-950 m-0">{userName}</p>
            <p className="text-xs text-slate-400 m-0">{new Date(date).toLocaleDateString('fr-FR')}</p>
          </div>
        </div>
        <StarDisplay rating={rating || 0} />
      </div>

      {message && <p className="text-sm text-slate-600 leading-relaxed m-0 mb-2">{message}</p>}

      {raw?.reviewReply?.comment && (
        <div className="px-3 py-2.5 rounded-lg bg-white border border-blue-100 border-l-4 border-l-blue-400 mt-2">
          <p className="text-[11px] font-semibold text-blue-400 uppercase tracking-wide m-0 mb-1">Réponse</p>
          <p className="text-sm text-slate-600 m-0">{raw.reviewReply.comment}</p>
        </div>
      )}

      {isAdmin && (
        <div className="flex flex-wrap items-center gap-2 mt-3 pt-3 border-t border-blue-50">
          {replyOpenFor === id ? (
            <>
              <input value={replyText} onChange={e => setReplyText(e.target.value)} placeholder="Votre réponse..." className={`${inputCls} flex-1 min-w-[200px]`} />
              <button onClick={() => onReplySubmit(review)} className="px-3 py-2 rounded-lg text-xs font-semibold text-white bg-gradient-to-r from-blue-500 to-blue-400">Répondre</button>
              <button onClick={() => { setReplyOpenFor(null); setReplyText(''); }} className="px-3 py-2 rounded-lg text-xs font-semibold bg-white text-blue-600 border border-blue-200">Annuler</button>
            </>
          ) : (
            <button onClick={() => setReplyOpenFor(id)} className="px-3 py-2 rounded-lg text-xs font-semibold bg-white text-blue-600 border border-blue-200">Répondre</button>
          )}

          {raw?.reviewReply?.comment && (
            <button onClick={() => onDeleteReply(review)} className="px-3 py-2 rounded-lg text-xs font-semibold text-white bg-gradient-to-r from-rose-500 to-rose-400">Supprimer la réponse</button>
          )}
        </div>
      )}
    </div>
  );
};